import React from 'react'
import { Button, InputGroup, FormGroup, FormControl } from 'react-bootstrap'

const SearchBar = ({ searchText, setSearchText, loading, placeholder, onSearch }) => (
  <form onSubmit={onSearch}>
    <FormGroup>
      <InputGroup>
        <FormControl
          type="text"
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          placeholder={placeholder}
          autoFocus
        />
        <Button type="submit" variant="primary" disabled={loading}>
          { loading ? "Loading..." : "Load Playlist" }
        </Button>
      </InputGroup>
    </FormGroup>
  </form>
)

export default SearchBar
